import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import React from 'react';
import type { SecuredComponentBaseProps } from '../../types';
import { useSecurity } from '../hooks/useSecurity';

type SecuredMenuItemProps = Omit<MenuItemProps, 'disabled'> &
    SecuredComponentBaseProps & {
        disabled?: boolean;
    };

export default function SecuredMenuItem({
    securityAction,
    securityTarget,
    securityEnforcementMode = 'hidden',
    fallback = null,
    disabled,
    ...menuItemProps
}: SecuredMenuItemProps) {
    const decision = useSecurity(securityAction, securityTarget);

    if (!decision.allowed && securityEnforcementMode === 'hidden') {
        return fallback;
    }

    const isDisabled = !decision.allowed || decision.pending;

    return <MenuItem {...menuItemProps} disabled={isDisabled || Boolean(disabled)} />;
}
